import { miniSerializeError, SerializedError } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
// import { Errors } from "../enums/errors.enums";
import { IStandardError } from "../types/error.types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isCSSOStandardError(err: any): err is IStandardError {
  if (err.isCSSOStandardError) {
    return true;
  } else {
    return false;
  }
}

export function serializedErrorToStandardError(
  serialError: SerializedError
): IStandardError {
  return {
    code: serialError.code,
    message: /* istanbul ignore next */ serialError.message ?? "",
    displayMessage: serialError.message,
    data: {
      stack: serialError.stack?.substring(0, 255),
    },
    isCCSOStandardError: true,
  };
}

export function errorToStandardError(error: Error): IStandardError {
  return serializedErrorToStandardError(miniSerializeError(error));
}

/* istanbul ignore next */
export function axiosErrorToStandardError(error: AxiosError): IStandardError {
  if (error.code === undefined) {
    const resp = error.response;
    if (resp !== undefined) {
      error.code = String(resp.status);
    }
  }
  return serializedErrorToStandardError(miniSerializeError(error));
}
/* istanbul ignore next */
export function convertError(e: object): IStandardError {
  if (axios.isAxiosError(e)) {
    return axiosErrorToStandardError(e);
  } else if (isCSSOStandardError(e)) {
    return e;
  } else if (e instanceof Error) {
    return errorToStandardError(e);
  } else {
    return serializedErrorToStandardError(e);
  }
}

/* istanbul ignore next */
export const useErrorHandling = (isError: boolean, error?: unknown) => {
  const h = useHistory();

  useEffect(() => {
    if (!isError) {
      return;
    }

    const e = error as IStandardError | SerializedError;
    if (e.code === "404" && h.location.pathname !== "/NotFound") {
      h.replace("/NotFound");
    } else if (
      String(e.code).startsWith("5") &&
      h.location.pathname !== "/ServerError"
    ) {
      h.replace("/ServerError");
    }
  }, [isError, error, h]);
};
